/**
 * Single source of truth for the user-facing Run vs Training noun.
 *
 * Display copy only — driven by the existing structured `court_type` field
 * (also drives the "Training" badge). NOT analytics/reporting/billing.
 *   court_type === 'training'        -> "Training"
 *   'half_court' | 'full_court' | _  -> "Run"  (safe default when absent)
 */
export const getRunNoun = (game) =>
  game?.court_type === 'training' ? 'Training' : 'Run';
